<template>
  <div>
    <span v-if="debug === 'true' || debug === true">{{version}}</span>
    <Header />

    <div class="bodyCenter">
      <div class="modalStyle">
        <div class="titulos">
          <div class="seccionTitle">
            <b-icon icon="bookmark-check-fill" class="mLeft"></b-icon>
            <div class="headerTxt mLeft">Cambio de especialista masivo</div>
          </div>
          <div class="alignIcon bold">Cambio_especi</div>
        </div>

        <div class="noAlTope" v-if="cargando">
          <b-button variant="primary" disabled>
            <b-spinner small></b-spinner>
            Cargando...
          </b-button>
        </div>

        <div class="noAlTope" v-else>
          <b-row>
            <b-col>
              <div class="text-left mb-4">
                <label>Clínica: </label>
                <b-form-select
                  v-model="idClinica"
                  :options="listaClinica"
                  v-on:change="buscarDoctores(idClinica)"
                  value-field="idClinica"
                  text-field="strNombre"
                >
                </b-form-select>
              </div>

              <b-form v-on:submit.prevent="buscarColaborador">
                <div class="text-left">
                  <label>Nombre de colaborador: </label>
                  <b-form-input
                    v-model="nombreColaborador"
                    minLength="8"
                    :state="nombreColaborador.length > 8"
                    required
                  >
                  </b-form-input>
                  <b-form-invalid-feedback
                    :state="nombreColaborador.length > 8"
                  >
                    minimo 8 letras
                  </b-form-invalid-feedback>
                </div>
                <b-button
                  class="mt-4"
                  variant="primary"
                  disabled
                  v-if="cargandoLista"
                >
                  <b-spinner small></b-spinner>
                  Cargando...
                </b-button>
                <b-button
                  class="mt-4"
                  type="submit"
                  variant="outline-primary"
                  v-else
                >
                  Buscar
                </b-button>
              </b-form>
            </b-col>
            <b-col>
              <b-form v-on:submit.prevent="cambiarColaborador">
                <div class="text-left">
                  <label>Nuevo colaborador: </label>
                  <b-form-select
                    v-model="idEmpleado"
                    :options="listaDoctores"
                    value-field="idEmpleado"
                    text-field="nombreDoctor"
                    :state="idEmpleado != null"
                    required
                  >
                  </b-form-select>
                  <b-form-invalid-feedback :state="idEmpleado != null">
                    Selecciona una opción
                  </b-form-invalid-feedback>
                </div>

                <div
                  class="text-left mt-4"
                  v-if="listaAntiguosColaboradores.length != 0"
                >
                  <label>Antiguo colaborador: </label>
                  <b-form-select
                    v-model="colaboradorAntiguo"
                    :options="listaAntiguosColaboradores"
                    value-field="idEmpleado"
                    text-field="nombre"
                    :state="colaboradorAntiguo != null"
                    required
                  >
                  </b-form-select>
                  <b-form-invalid-feedback :state="colaboradorAntiguo != null">
                    Selecciona una opción
                  </b-form-invalid-feedback>
                </div>
                <div v-if="listaAntiguosColaboradores.length != 0">
                  <b-button
                    class="mt-4"
                    variant="primary"
                    disabled
                    v-if="enviando"
                  >
                    <b-spinner small></b-spinner>
                    Cargando...
                  </b-button>
                  <b-button
                    class="mt-4"
                    type="submit"
                    variant="outline-primary"
                    v-else
                  >
                    Guardar
                  </b-button>
                </div>
              </b-form>
            </b-col>
          </b-row>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Header from "../../components/Header.vue";
import VueNotifications from "vue-notifications";

export default {
  name: "CambioEspecialistaTratamientos",
  components: {
    Header,
  },
  data: () => ({
    version: process.env.VUE_APP_ENV_VERSION,
    debug: false,

    nombreColaborador: "",
    listaAntiguosColaboradores: [],
    colaboradorAntiguo: null,
    cargandoLista: false,
    listaClinica: [],
    listaDoctores: [],
    idClinica: null,
    idEmpleado: null,
    cargando: false,
    enviando: false,
  }),
  created() {
    this.debug = this.$localStorageService.getDebug();

    this.traerClinicas();
  },
  methods: {
    traerClinicas() {
      const url = this.$api + "catalogos/listaClinicas";
      this.$http
        .get(url)
        .then((response) => {
          if (response.status === 200) {
            response.data.data.unshift({
              idClinica: null,
              strNombre: "Clinica :",
            });
            this.listaClinica = response.data.data;
            this.cargando = false;
          }
        })
        .catch((err) => {
          this.cargando = false;
          this.showErroMsg(err);
        });
    },
    buscarDoctores(clinica) {
      const url = this.$api + "colaboradores/clinica?idClinica=" + clinica;
      this.$http.get(url).then((response) => {
        response.data.data.unshift({
          idEmpleado: null,
          nombreDoctor: "Nuevo colaborador:",
        });
        this.listaDoctores = response.data.data;
      });
    },
    buscarColaborador() {
      this.cargandoLista = true;
      const url =
        this.$api +
        "colaboradores/registros?nombreEmpleado=" +
        this.nombreColaborador;

      this.$http
        .get(url)
        .then((response) => {
          response.data.data.unshift({
            idEmpleado: null,
            nombre: "Antiguo colaborador:",
          });
          this.listaAntiguosColaboradores = response.data.data;
          this.cargandoLista = false;
        })
        .catch((err) => {
          this.cargandoLista = false;
          this.errorTraer(err);
        });
    },
    cambiarColaborador() {
      this.enviando = true;

      const url = this.$api + "diagnostico/especialista";
      const parametros = {
        idEmpleadoAntiguo: this.colaboradorAntiguo,
        idEmpleadoNuevo: this.idEmpleado,
        idClinica: this.idClinica,
      };

      this.$http
        .put(url, parametros)
        .then((response) => {
          if (response.status === 200) {
            this.$swal({
              icon: "success",
              text: "Se envio la información correctamente",
              confirmButtonText: "OK",
              confirmButtonColor: "#0e6ba9",
            });
            setTimeout(() => location.reload(), 2000);
            this.enviando = false;
          }
        })
        .catch((err) => {
          this.enviando = false;
          this.errorEnviar(err);
        });
    },
  },
  notifications: {
    errorTraer: {
      type: VueNotifications.types.error,
      title: "Error",
      message: "Error al traer la información",
    },
    errorEnviar: {
      type: VueNotifications.types.error,
      title: "Error",
      message: "Error al enviar la información",
    },
  },
};
</script>

<style>
</style>